import AjaxInvitationService from './ajax-invitation-service'

class GuestService extends AjaxInvitationService {
  createUserByCode ( data ) {
    let headers = this.getInvitationHeader(data.code)
    return this.makePostRequest('/by-invitation/guests', JSON.stringify(data), headers )
  }

  updateUserByCode (id, data) {
    let headers = this.getInvitationHeader(data.code)
    return this.makePutRequest(`/by-invitation/guests/${id}`, data, headers)
  }

  verifyCode( code ) {
    return this.makeGetRequest('/guest-codes/check', { code:code })
  }
}

const _instance = new GuestService()
export default _instance